import {NgModule} from '@angular/core';

import {MatButtonModule} from '@angular/material/button';
import {MatDialogModule} from '@angular/material/dialog';
import {ButtonModule, TableModule} from '@ucx/ui-cmp';
import {AmountModalComponent} from './amount-modal.component';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {ReactiveFormsModule} from '@angular/forms';
import {MatTableModule} from '@angular/material/table';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatSelectModule} from '@angular/material/select';
import {MatTabsModule} from '@angular/material/tabs';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatNativeDateModule} from '@angular/material/core';
import {PaginatorModule} from '../paginator/paginator.module';
import {MatInputModule} from '@angular/material/input';
import {MatIconModule} from '@angular/material/icon';
import {MatMenuModule} from '@angular/material/menu';
import {TableExporterModule} from '../../../../shared/components/table-exporter/table-exporter.module';
import {MatSortModule} from '@angular/material/sort';
import {FilterModule} from '../../../../shared/components/filter/filter.module';
import {NgxMatSelectSearchModule} from 'ngx-mat-select-search';
import {SpinnerButtonModule} from '../spinner-button/spinner-button.module';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatRadioModule} from '@angular/material/radio';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {NgxDropzoneModule} from 'ngx-dropzone';
import {MatChipsModule} from '@angular/material/chips';
import {InvalidControlScrollModule} from '../../../../shared/utils/InvalidControlScroll/InvalidControlScroll.module';
import {InputTrimmerModule} from '../input-trimmer/input-trimmer.module';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatTooltipModule} from '@angular/material/tooltip';
import {TooltipModule} from '../tooltip/tooltip.module';
import {CharCounterTextareaModule} from 'src/app/shared/components/char-counter-textarea/char-counter-textarea.module';

@NgModule({
  declarations: [
    AmountModalComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    MatTableModule,
    MatCheckboxModule,
    MatDialogModule,
    MatButtonModule,
    MatSelectModule,
    MatTabsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    PaginatorModule,
    MatInputModule,
    MatIconModule,
    MatMenuModule,
    TableExporterModule,
    MatSortModule,
    FilterModule,
    NgxMatSelectSearchModule,
    SpinnerButtonModule,
    MatProgressSpinnerModule,
    ButtonModule,
    TableModule,
    MatRadioModule,
    MatProgressBarModule,
    NgxDropzoneModule,
    MatChipsModule,
    InvalidControlScrollModule,
    InputTrimmerModule,
    MatExpansionModule,
    MatTooltipModule,
    TooltipModule,
    CharCounterTextareaModule
  ],
  providers: [],
  exports: [
    AmountModalComponent
  ]
})
export class AmountModalModule {
}
